export enum NotificationsActionType {
  CarRefuel = "car_refuel",
  CallIncoming = "call_incoming",
  EngineStart = "engine_start",
  EngineEnd = "engine_end",
  InventoryTradeFailed = "InventoryTradeFailed",
  InventoryTradeSuccess = "InventoryTradeSuccess",
  InventoryTradeCancelled = "InventoryTradeCancelled", // моя инцицатива
  InventoryTradeCancelledOther = "InventoryTradeCancelledOther", // иницатива другого игрока
  InventoryNotEnoughSpace = "InventoryNotEnoughSpace",
  InventoryNotEnoughSpaceOther = "InventoryNotEnoughSpaceOther",
  InventoryTradeNotEnoughMoneyOther = "InventoryTradeNotEnoughMoneyOther",
  NotificationSystemTypeInventoryTradeFailed = "NotificationSystemTypeInventoryTradeFailed",
  FridgeNotEnoughtProducts = "FridgeNotEnoughtProducts",
  FridgeProductsRestocked = "FridgeProductsRestocked",
  NotEnoughMoney = "NotEnoughMoney",
}
